import { useSessionStore } from '@/src/hooks/use_session_store'
import { DATA_MANAGEMENT_BASE_ROUTE, TABS } from '@/src/utils/constants'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

import React, { Suspense } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
const AnalyticsOverviewPageLazy = React.lazy(() => import('./Datenmanagement.page'))

const TimeSeriesDataOverviewLazy = React.lazy(() => import('./data-management/TimeSeriesDataOverview.page'))
const DataExportScreenLazy = React.lazy(() => import('./export/DataExport.screen'))
const ManualMeterUploadHistoryLazy = React.lazy(() => import('./manual-meters/ManualMeterUploadHistory.page'))
const ManualMeterUploadNewLazy = React.lazy(() => import('./manual-meters/ManualMeterUploadNew.page'))
const ManualMeterUploadDetailLazy = React.lazy(() => import('./manual-meters/ManualMeterUploadDetail.page'))

const ManualMeterUploadWriteRoute = ({ children }: { children: React.ReactNode }) => {
  const isReadonly = useSessionStore().user?.readonly
  return isReadonly ? (
    <Navigate replace to={`${DATA_MANAGEMENT_BASE_ROUTE}/${TABS.datenmanagement.manualMeters}`} />
  ) : (
    <Suspense fallback={<div />}>{children}</Suspense>
  )
}

const AnalyticsOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsOverviewPageLazy />
  </Suspense>
)

const CustomDataOverviewPage = (
  <Suspense fallback={<div></div>}>
    <TimeSeriesDataOverviewLazy />
  </Suspense>
)

const DataExportPage = (
  <Suspense fallback={<div></div>}>
    <DataExportScreenLazy />
  </Suspense>
)

export const dataManagementRoutes: RouteObject[] = [
  {
    path: DATA_MANAGEMENT_BASE_ROUTE,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      { path: '', element: <Navigate replace to={TABS.datenmanagement.timeSeries} /> },
      {
        path: '',
        element: AnalyticsOverviewPage,
        children: [
          { path: TABS.datenmanagement.timeSeries, element: CustomDataOverviewPage },
          { path: TABS.datenmanagement.export, element: DataExportPage },
          {
            path: TABS.datenmanagement.manualMeters,
            element: (
              <Suspense fallback={<div />}>
                <ManualMeterUploadHistoryLazy />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: `${TABS.datenmanagement.manualMeters}/new`,
        element: (
          <ManualMeterUploadWriteRoute>
            <ManualMeterUploadNewLazy />
          </ManualMeterUploadWriteRoute>
        ),
      },
      {
        path: `${TABS.datenmanagement.manualMeters}/:id`,
        element: (
          <Suspense fallback={<div />}>
            <ManualMeterUploadDetailLazy />
          </Suspense>
        ),
      },
    ],
  },
]
